<template>
  <div class="irp-key-contacts-panel" data-testid="irp-key-contacts-panel"
    >Recommended key contacts</div
  >
</template>
